








import VueOptions from '@utils/VueOptions'
import FormFieldRadioButton from '@ui/FormBuilder/FormFields/FormFieldRadioButton'

settings =
  name: 'FormFieldCancellationPolicy'

  vue:
    props: ['value', 'errors']

    components: {
      FormFieldRadioButton,
    }

    data: ->
      value_: @value || []

    computed:
      optionsForCancellationPolicy: ->
        [
          {
            label: 'Loose',
            value: 'loose'
          },
          {
            label: 'Moderate',
            value: 'moderate'
          },
          {
            label: 'Strict',
            value: 'strict'
          }
        ]

    methods:
      hiInputChange: (value) ->
        @$emit 'input', value
        @$emit 'change', value

export default VueOptions.vue settings
